import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Industries from "@/pages/Industries";

export const Route = createFileRoute("/en/industries/")({
  head: () => buildRouteHead("/en/industries"),
  component: Industries,
});

